import { every } from 'lodash';
import {
  UnitFormModel,
  unitHasAtMostOneRadiatorManifold,
  unitHasHeatPumpIfItHasRadiatorManifold,
} from './unitFormModel';

export const haveAtLeastOneUnit = {
  predicate: (_: unknown, { units }: { units: Array<UnitFormModel> }) => units.length > 0,
  message: 'Please add at least one Unit.',
};

export const haveHeatPumpOnEveryUnitThatHasRadiatorManifold = {
  predicate: (_: unknown, { units }: { units: Array<UnitFormModel> }) =>
    every(units, unit => unitHasHeatPumpIfItHasRadiatorManifold(unit)),
  message: 'If a Unit has a Radiator Manifold then it must also have a Heat Pump.',
};

export const haveAtMostOneRadiatorManifoldOnEachUnit = {
  predicate: (_: unknown, { units }: { units: Array<UnitFormModel> }) =>
    every(units, unit => unitHasAtMostOneRadiatorManifold(unit)),
  message: 'A Unit cannot have more than one Radiator Manifold.',
};
